import TileSprite = Phaser.GameObjects.TileSprite;
import Sprite = Phaser.GameObjects.Sprite;

export class TileRoad {
    id!: number;
    yFrom!: number;
    yTo!: number;
    tileSprite: TileSprite | undefined;
    sprite: Sprite | undefined;
}
